import type { LOAN_REQUEST_OFFER_SOURCE } from 'cpool-constants';
import type { Resolver } from 'cpool-schemas';
import type { z } from 'zod';

import { schemaAcceptedOffersCommon } from '../tables';

type Arguments = {
    id: string;
    offerId: string;
    source: LOAN_REQUEST_OFFER_SOURCE;
};
export const schemaLoanRequestResolver_GetOfferAcceptanceStatusByOfferId =
    schemaAcceptedOffersCommon.shape.acceptanceStatus.nullable();

export type SchemaLoanRequestResolver_GetOfferAcceptanceStatusByOfferId = z.infer<
    typeof schemaLoanRequestResolver_GetOfferAcceptanceStatusByOfferId
>;

export type LoanRequestResolver_GetOfferAcceptanceStatusByOfferId = Resolver<
    Arguments,
    SchemaLoanRequestResolver_GetOfferAcceptanceStatusByOfferId
>;
